<template>
  <v-container fluid>
    <div class="scrollable-content"  ref="scrollContainer">
      <v-row class="time-row">
        <v-col cols="6" align="start" v-for="(time, index) in localEventTimes" :key="index">
          <v-list-item dense
            @click="onTimeSelected(time)"
            :class="['time-item', timeClass(time)]"
            :ref="time.time === '06:00' ? 'sixAM' : null"
          >
            <v-list-item-content class="costumize-time-select">
              {{ time.time }}
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
    </div>
    <!-- Botão fixo sempre no fundo -->

  </v-container>
</template>

  
  <script>
  import Events from '@/api/Events.js';
  //import { mapState } from 'vuex';

  export default {
    props: {
    selectedDate: {
      type: String,
      required: true
    },
    eventTimes: {
      type: Array,
      default: () => []
    },
    selectedOption: {
      type: Number,
      required: true
    },
    autoSelectAll: {
      type: Boolean,
      default: false
    },
    minDurationValue: {
      type: Number,
      default: 0
    }
    
  },

    computed: {
        filteredEventTimes() {
        return this.eventTimes.filter(item => item.date === this.selectedDate).map(item => item.time);
        }
    },

    data() {
      return {
        localEventTimes:[],
        selectedTimes: [],
        options: [
        { value: 1, class: 'red-button' },
        { value: 2, class: 'yellow-button' },
        { value: 3, class: 'green-button' },
      ],
      };
    },
    methods: {
expandTimes(date, eventTimes) {
  const expandedTimes = [];
  if (!eventTimes || eventTimes.length === 0) return expandedTimes;

  // Detecta se é voto de dia inteiro
  const fullDayVote = eventTimes.some(t => t.time === '00:00') &&
                      eventTimes.some(t => t.time === '23:59');
  const defaultValue = fullDayVote ? eventTimes[0].value : null;

  // Ordena os horários para garantir início e fim corretos
  const sortedTimes = eventTimes
    .map(t => ({...t}))
    .sort((a, b) => a.time.localeCompare(b.time));

  const startStr = sortedTimes[0].time;
  const endStr = sortedTimes[sortedTimes.length - 1].time;

  let [h, m] = startStr.split(':').map(Number);
  let start = new Date(`${date}T${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')}:00`);

  const [endH, endM] = endStr.split(':').map(Number);
  const end = new Date(`${date}T${String(endH).padStart(2,'0')}:${String(endM).padStart(2,'0')}:00`);

  while (start < end) {
    const nextTime = new Date(start.getTime() + 30 * 60000);

    const hh1 = String(start.getHours()).padStart(2,'0');
    const mm1 = String(start.getMinutes()).padStart(2,'0');
    const hh2 = String(nextTime.getHours()).padStart(2,'0');
    const mm2 = String(nextTime.getMinutes()).padStart(2,'0');

    // Busca voto que se encaixa dentro do intervalo
    const matchingVote = eventTimes.find(t => {
      const [th, tm] = t.time.split(':').map(Number);
      const voteTime = new Date(`${date}T${String(th).padStart(2,'0')}:${String(tm).padStart(2,'0')}:00`);
      return voteTime >= start && voteTime < nextTime;
    });

    const value = matchingVote?.value ?? defaultValue ?? null;

    expandedTimes.push({
      date,
      time: `${hh1}:${mm1} - ${hh2}:${mm2}`,
      value,
      id: `${date}-${hh1}:${mm1}`
    });

    start = nextTime;
  }

  return expandedTimes;
},

      async saveTimes() {
        try {
           const votes = (this.localEventTimes || []).filter(t => t.value != null).map(time => {
 
    const [startStr, endStr] = time.time.split(' - ')
    const vote_start = `${this.selectedDate}T${startStr}:00`
    const vote_end   = `${this.selectedDate}T${endStr}:00`

    return {
      vote_start,
      vote_end,
      vote_value: time.value
    }
  })

  const params = {
    user_id: this.$root.session.id,
    event_id: this.$route.params.id,
    date: this.selectedDate,
    votes
  }

  console.log("Salvando horários votados:", params)
  Events.insertTime(params)

          this.$emit('reload-calendar');
        } catch (error) {
          console.error("Erro:", error);
        }
    },

      timeClass(time) {        
        const value = time.value

        switch (value) {
          case 1:
            return 'red-time';
          case 2:
            return 'yellow-time';
          case 3:
            return 'green-time';
          default:
            return '';
        }
      },
      onOptionSelected(option) {
        this.$emit('option-selected', option);
      },

        onTimeSelected(time) {
        time.value = this.selectedOption
        this.$forceUpdate()
        this.saveTimes()
      },
    },
    created() {
      this.localEventTimes = [...this.expandTimes(this.selectedDate, this.eventTimes)]; if (this.autoSelectAll) { this.localEventTimes = this.localEventTimes.map(t => ({ ...t, value: this.selectedOption })) 
    this.saveTimes() } this.$nextTick(() => { setTimeout(() => { const container = this.$refs.scrollContainer;  
    const timeItems = container?.querySelectorAll('.time-item'); const sixAM = Array.from(timeItems || []).find(item => item.textContent.includes('06:00') ); if (sixAM && container) { sixAM.scrollIntoView({ behavior: 'smooth', block: 'start' }); } }, 200); }); },

    watch: {
  selectedDate(newDate) {
    this.localEventTimes = [...this.expandTimes(newDate, this.eventTimes)];
  }
  },
};
  </script>
  
  <style scoped>
.theme--light {
  color: rgba(0, 0, 0, 0) !important;
  box-shadow: none !important;
}
.costumize-time-select {
  background-color: transparent !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  width: 100% ;
  font-size: 15px; /* Ajustado o tamanho da fonte */
  color: #000000;
}

.time-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between; /* Garante distribuição correta em duas colunas */
  align-items: flex-start; /* Mantém alinhamento correto das linhas */
}

.v-col {
  display: flex;
  flex: 1 1 48%; /* Mantém 2 colunas sempre com largura igual */
  justify-content: center;
  align-items: center;
}

.time-item {
  flex-grow: 1;
  width: 100%; /* Garante que o item usa todo o espaço disponível na coluna */
  height: 30px !important;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border: 1px solid #000;
  border-radius: 30px;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  font-size: 18px;
  white-space: nowrap;
}

.time-item:hover {
  transform: translateY(-2px);
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2);
}

.scrollable-content {
  flex: 1;
  overflow-y: auto;
  padding-bottom: 30px; /* Evita que o botão cubra os últimos elementos */
}




/* Botão fixo no fundo, SEMPRE VISÍVEL */
.save-button {
  position: sticky;
  bottom: 0;
  width: 100%;
  height: 60px;
  border-radius: 35px;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  background-color: black;
  color: white;
}

  .container {
    position: relative;
    display: flex;
    flex-direction: column;
    overflow: hidden; /* Para evitar qualquer deslocamento inesperado */
  }

.main-div{
  position: relative;
    width: 100% !important;
    height: 70vh !important;
    overflow: hidden;
}

  .costum-v-list-item-content {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    width: 100% ;
    font-size: 15px; /* Ajustado o tamanho da fonte */
    color: #000000;
  }
  
  .time-item .v-list-item-content::after {
    content: '>';
    font-size: 16px; /* Ajustado o tamanho da fonte */
    color: #6c63ff;
  }
  
  .time-item.selected {
    background-color: #6c63ff;
    color: #fff;
  }
  
  .time-item.selected .v-list-item-content {
    color: #fff;
  }
  
  .red-time {
    background-color: #fa9a9a;
  }
  
  .yellow-time {
    background-color: #f5e720;
  }
  
  .green-time {
    background-color: #cbd8c7;
  }

 
  .scrollable-content::-webkit-scrollbar {
    display: none; /* Oculta a barra de rolagem no Chrome, Safari e Opera */
  }

  
  @media (max-width: 960px) {
    .time-item {
      flex-grow: 1;
      width: 100%; /* Permite mais espaço para o texto */
      height: 60px; /* Aumenta ligeiramente a altura */
      max-width: 180px; /* Evita que fique muito pequeno */
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 30px;
      box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);
      cursor: pointer;
      transition: transform 0.3s ease, box-shadow 0.3s ease;
      font-size: 14px; /* Fonte ligeiramente maior para melhorar a leitura */
      white-space: nowrap; /* Garante que o texto não quebra */
      padding: 0 10px; /* Adiciona um pouco mais de espaço interno */
    }

    .costumize-time-select {
      background-color: transparent !important;
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
      width: 100%;
      font-size: 14px; /* Ajuste de tamanho para não cortar */
      color: #000000;
    }

    .costum-v-list-item-content {
      font-size: 11px;  /* Tamanho da fonte menor para dispositivos móveis */
    }
  }
  </style>

  

